export const bootFiles = [
  import(/* webpackMode: "eager" */ './sanitize.js'),
  import(/* webpackMode: "eager" */ './i18n.js'),
  import(/* webpackMode: "eager" */ './apollo.js'),
  import(/* webpackMode: "eager" */ './errorHandler.js'),
  import(/* webpackMode: "eager" */ './orderEvents.js'),
  import(/* webpackMode: "eager" */ './mock.js')
]
